<template>
  <div class="target-list">
    <md-chip
      v-for="(target, index) in targets"
      :key="target.principalType + target.principalId"
      class="md-white"
      md-deletable
      @md-delete="(t, idx) => deleteTarget(target, index)"
    >
      {{ target.label }}
    </md-chip>
  </div>
</template>

<script>
export default {
  name: 'target-list',
  props: {
    targets: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    deleteTarget(target, index) {
      this.$emit('deleteTarget', this.targets[index]);
    },
  }
}
</script>

<style scoped>
.target-list {
  padding: 15px;
  background-color: #e8e8e8;
  width: 100%;
  height: 180px;
}
.md-chip {
  margin-left: 0;
  margin-right: 8px;
  margin-bottom: 15px;
}

.md-white {
  background-color: white;
}

.md-white >>> .md-ripple {
  background-color: #a9b3bc;
}
</style>